import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

function FormHeader({ sx, children }: Readonly<{ sx?: SxProps<Theme>; children: React.ReactNode }>) {
  return (
    <Box sx={{ color: 'white', ...sx }}>
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: 700,
          letterSpacing: '-0.02em',
          textShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}

export default FormHeader;
